export default {
    methods: {
        rotateImage(base64Uri, degrees) {
            return new Promise(function(resolve, reject) {
                //assume 90 degrees if not provided
                degrees = degrees ? degrees : 90;
                
                var canvas = document.createElement("canvas");
                canvas.setAttribute("id", "hidden-canvas");
                canvas.style.display = "none";
                document.body.appendChild(canvas);
                
                var ctx = canvas.getContext("2d");
            
                var image = new Image();
                image.src = base64Uri;
                image.onload = function() {
                    var w = image.width;
                    var h = image.height;
                    var rads = degrees * Math.PI/180;
                    var c = Math.cos(rads);
                    var s = Math.sin(rads);
                    if (s < 0) { s = -s; }
                    if (c < 0) { c = -c; }

                    //use translated width and height for new canvas
                    canvas.width = h * s + w * c;
                    canvas.height = h * c + w * s;

                    //draw the rect in the center of the newly sized canvas
                    ctx.translate(canvas.width/2, canvas.height/2);
                    ctx.rotate(degrees * Math.PI / 180);
                    ctx.drawImage(image, -image.width/2, -image.height/2);

                    resolve(canvas.toDataURL('image/jpeg', 0.9));
                    document.body.removeChild(canvas);
                };
                image.onerror = function() {
                    reject("Failed to rotate image");
                };
            });
        }
    }
}